import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _spliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/splice';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import React__default, { forwardRef, useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import AdvancedTableColumnHeaderMenu from './e2de1a1948e74450082ce31fb21b6fedb85e99e9ba67019bdd5ef19ff0687f64.cfe-internal.js';
import useDragAndDrop from './fcda8d02073f7326d2cbd17fee975ad0099461a73d487525cf244b0e79eb5799.cfe-internal.js';
import styles from './911805e7d0f3f24d5c4539dfbcbf0ca9410ef311f2044b4b999baa91b0b8e88b.cfe-internal.js';
import '../629495c61f6f3ffdfe2248a13b452d018cea8d55bb88c94e497bf6f5395fc2fd.cfe-internal.js';
import '../../icons/index.es.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import useComputedWidth from './3e62b007b8a431629c15dd67376756dec11a706834ec7f4e7b63f14fd471f544.cfe-internal.js';
import useEventListener from '../../hooks/useEventListener/d298373edbbbe27e03edc667e68a196078d5abecbf27f9b61af0b7bc7dd7b6a0.cfe-internal.js';
import Tooltip from '../Tooltip/303de8f785b9987afea88aa6b28176d2cc278b105d33ed5d93d1cf139ee9589d.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';
import IconButton from '../IconButton/399631eebecc03da030561fb1a25c35c2d29c5e4645700b7fca3cf592ca75904.cfe-internal.js';
import ChevronDownIcon from '../../icons/components/7c7c780956cb4e93fe69a1384927ee5fbe6526f5bb2422c9d44843841947bab7.cfe-internal.js';

var AdvancedTableColumnHeader = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id,
    dataTestId = _ref['data-testid'],
    label = _ref.label,
    width = _ref.width,
    widthBuffer = _ref.widthBuffer,
    onWidthChange = _ref.onWidthChange,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? 'left' : _ref$alignment,
    columnIndex = _ref.columnIndex,
    isFocused = _ref.isFocused,
    sortOptions = _ref.sortOptions,
    selectedSortOption = _ref.selectedSortOption,
    setSelectedSortOption = _ref.setSelectedSortOption,
    onKeyDown = _ref.onKeyDown,
    onFocus = _ref.onFocus,
    setFocusedColumnId = _ref.setFocusedColumnId,
    minUnpinnedColumnIndex = _ref.minUnpinnedColumnIndex,
    maxUnpinnedColumnIndex = _ref.maxUnpinnedColumnIndex,
    disableUserPinnableColumns = _ref.disableUserPinnableColumns,
    isPinned = _ref.isPinned,
    setPinnedColumns = _ref.setPinnedColumns,
    disableUserReorderableColumns = _ref.disableUserReorderableColumns,
    setColumnOrder = _ref.setColumnOrder,
    isDragging = _ref.isDragging,
    setDragSource = _ref.setDragSource,
    setDropTarget = _ref.setDropTarget,
    dropTargetSide = _ref.dropTargetSide,
    setDropTargetSide = _ref.setDropTargetSide,
    tableId = _ref.tableId,
    tableHeight = _ref.tableHeight,
    isRowActionMenuColumn = _ref.isRowActionMenuColumn,
    isFinalNonRowActionsColumn = _ref.isFinalNonRowActionsColumn;
  var labelRef = useRef(null);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    ellipsisShown = _useState2[0],
    setEllipsisShown = _useState2[1];
  var columnHeaderRef = useRef(null);
  var labelContainerRef = useRef(null);
  var isSortable = Boolean(sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.length);
  var isSorted = isSortable && selectedSortOption.columnId === id && selectedSortOption.index >= 0 && selectedSortOption.index < (sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.length) && (selectedSortOption.direction === 'ascending' || selectedSortOption.direction === 'descending');
  var selectedSortIndex = isSorted ? selectedSortOption.index : -1;
  var arrowUpSvgContent = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1249 0.5C5.53911 0.5 5.8749 0.835786 5.8749 1.25V8.75C5.8749 9.16422 5.53911 9.5 5.1249 9.5C4.71068 9.5 4.3749 9.16422 4.3749 8.75V1.25C4.3749 0.835786 4.71068 0.5 5.1249 0.5Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59467 0.71967C4.88756 0.426777 5.36244 0.426777 5.65533 0.71967L9.15533 4.21967C9.44822 4.51256 9.44822 4.98744 9.15533 5.28033C8.86244 5.57322 8.38756 5.57322 8.09467 5.28033L5.125 2.31066L2.15533 5.28033C1.86244 5.57322 1.38756 5.57322 1.09467 5.28033C0.801777 4.98744 0.801777 4.51256 1.09467 4.21967L4.59467 0.71967Z"
  }));
  var arrowDownSvgContent = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1249 0.5C5.53911 0.5 5.8749 0.835786 5.8749 1.25V8.75C5.8749 9.16422 5.53911 9.5 5.1249 9.5C4.71068 9.5 4.3749 9.16422 4.3749 8.75V1.25C4.3749 0.835786 4.71068 0.5 5.1249 0.5Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.09467 4.71962C1.38756 4.42673 1.86244 4.42673 2.15533 4.71962L5.125 7.68929L8.09467 4.71962C8.38756 4.42673 8.86244 4.42673 9.15533 4.71962C9.44822 5.01251 9.44822 5.48739 9.15533 5.78028L5.65533 9.28028C5.36244 9.57317 4.88756 9.57317 4.59467 9.28028L1.09467 5.78028C0.801777 5.48739 0.801777 5.01251 1.09467 4.71962Z"
  }));
  var selectedSortIcon = isSorted ? /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    className: styles.sortIcon,
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, selectedSortOption.direction === 'ascending' ? arrowUpSvgContent : arrowDownSvgContent) : undefined;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isResizing = _useState4[0],
    setIsResizing = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isMenuOpen = _useState6[0],
    setIsMenuOpen = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isHiddenMenuOpen = _useState8[0],
    setIsHiddenMenuOpen = _useState8[1];
  var _useState9 = useState(-1),
    _useState10 = _slicedToArray(_useState9, 2),
    hiddenMenuHighlightedIndex = _useState10[0],
    setHiddenMenuHighlightedIndex = _useState10[1];
  var hasMenu = !isRowActionMenuColumn && (isSortable || !disableUserPinnableColumns || !disableUserReorderableColumns);
  var hasDraggableColumns = !disableUserPinnableColumns && !disableUserReorderableColumns && !isRowActionMenuColumn;
  var _useDragAndDrop = useDragAndDrop({
      isEnabled: hasDraggableColumns,
      id: id,
      tableId: tableId,
      columnIndex: columnIndex,
      columnHeaderRef: columnHeaderRef,
      isPinned: isPinned,
      setPinnedColumns: setPinnedColumns,
      setColumnOrder: setColumnOrder,
      setDragSource: setDragSource,
      setDropTarget: setDropTarget,
      dropTargetSide: dropTargetSide,
      setDropTargetSide: setDropTargetSide
    }),
    dragRef = _useDragAndDrop.dragRef,
    dropRef = _useDragAndDrop.dropRef;

  /**
   * Note: Screen reader descriptions (aria-describedby) of column header keyboard shorcuts were not added due to a suboptimal
   * VoiceOver experience in multiple browsers: description read twice, description read before the header contents, etc. Keep
   * in mind this is not a WCAG 2.0 AA violation.
   */
  var handleKeyDown = function handleKeyDown(e) {
    if (e.target !== e.currentTarget) return;
    if (hasMenu && e.key === 'Enter') {
      setIsHiddenMenuOpen(true);
      setHiddenMenuHighlightedIndex(0);
    } else if (onWidthChange && e.key === 'ArrowRight' && e.shiftKey) {
      var _columnHeaderRef$curr;
      e.preventDefault(); // prevent scroll
      var _newWidth = ((_columnHeaderRef$curr = columnHeaderRef.current) === null || _columnHeaderRef$curr === void 0 ? void 0 : _columnHeaderRef$curr.getBoundingClientRect().width) + 10;
      onWidthChange(_newWidth);
    } else if (onWidthChange && e.key === 'ArrowLeft' && e.shiftKey) {
      var _columnHeaderRef$curr2;
      e.preventDefault(); // prevent scroll
      var _newWidth2 = Math.max(80, ((_columnHeaderRef$curr2 = columnHeaderRef.current) === null || _columnHeaderRef$curr2 === void 0 ? void 0 : _columnHeaderRef$curr2.getBoundingClientRect().width) - 10);
      onWidthChange(_newWidth2);
    } else {
      onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    }
  };
  var handleClick = function handleClick(e) {
    var _labelContainerRef$cu;
    if (e.target === e.currentTarget || (_labelContainerRef$cu = labelContainerRef.current) !== null && _labelContainerRef$cu !== void 0 && _labelContainerRef$cu.contains(e.target)) {
      var newIndex = isSorted ? selectedSortIndex : 0;
      var newDirection = isSorted && selectedSortOption.direction === 'ascending' ? 'descending' : 'ascending';
      setSelectedSortOption({
        columnId: id,
        index: newIndex,
        direction: newDirection
      });
    }
  };
  var handleIsPinnedChange = function handleIsPinnedChange(newIsPinned) {
    if (newIsPinned) {
      setPinnedColumns(function (currentPinnedColumns) {
        var _context;
        return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(currentPinnedColumns), [id]);
      });
    } else {
      setPinnedColumns(function (currentPinnedColumns) {
        return _filterInstanceProperty(currentPinnedColumns).call(currentPinnedColumns, function (pinnedColumnId) {
          return id !== pinnedColumnId;
        });
      });
    }
    setFocusedColumnId(id);
  };
  var handleMoveLeft = function handleMoveLeft() {
    if (isPinned) {
      setPinnedColumns(function (currentPinnedColumns) {
        var newPinnedColumns = _toConsumableArray(currentPinnedColumns);
        _spliceInstanceProperty(newPinnedColumns).call(newPinnedColumns, columnIndex, 1);
        _spliceInstanceProperty(newPinnedColumns).call(newPinnedColumns, columnIndex - 1, 0, id);
        return newPinnedColumns;
      });
    } else {
      setColumnOrder(function (currentColumnOrder) {
        var newColumnOrder = _toConsumableArray(currentColumnOrder);
        var currentIndex = _indexOfInstanceProperty(newColumnOrder).call(newColumnOrder, id);
        _spliceInstanceProperty(newColumnOrder).call(newColumnOrder, currentIndex, 1);
        _spliceInstanceProperty(newColumnOrder).call(newColumnOrder, currentIndex - 1, 0, id);
        return newColumnOrder;
      });
    }
    setFocusedColumnId(id);
  };
  var handleMoveRight = function handleMoveRight() {
    if (isPinned) {
      setPinnedColumns(function (currentPinnedColumns) {
        var newPinnedColumns = _toConsumableArray(currentPinnedColumns);
        _spliceInstanceProperty(newPinnedColumns).call(newPinnedColumns, columnIndex, 1);
        _spliceInstanceProperty(newPinnedColumns).call(newPinnedColumns, columnIndex + 1, 0, id);
        return newPinnedColumns;
      });
    } else {
      setColumnOrder(function (currentColumnOrder) {
        var newColumnOrder = _toConsumableArray(currentColumnOrder);
        var currentIndex = _indexOfInstanceProperty(newColumnOrder).call(newColumnOrder, id);
        _spliceInstanceProperty(newColumnOrder).call(newColumnOrder, currentIndex, 1);
        _spliceInstanceProperty(newColumnOrder).call(newColumnOrder, currentIndex + 1, 0, id);
        return newColumnOrder;
      });
    }
    setFocusedColumnId(id);
  };
  var handleMouseDown = function handleMouseDown(e) {
    if (e.button === 0) {
      // left mouse button
      e.preventDefault(); // prevent focus from changing
      e.stopPropagation(); // prevent columns from being clicked and changing sort direction
      setIsResizing(true);
    }
  };
  var handleMouseMove = function handleMouseMove(e) {
    var _columnHeaderRef$curr3;
    var mouseX = e.clientX;
    var headerX = (_columnHeaderRef$curr3 = columnHeaderRef.current) === null || _columnHeaderRef$curr3 === void 0 ? void 0 : _columnHeaderRef$curr3.getBoundingClientRect().x;
    var newWidth = Math.max(80, mouseX - headerX);
    onWidthChange === null || onWidthChange === void 0 || onWidthChange(newWidth);
  };
  var handleMouseUp = function handleMouseUp(e) {
    if (e.button === 0) {
      setIsResizing(false);
    }
  };
  var options = {
    isDisabled: !isResizing
  };
  useEventListener(window, 'mousemove', handleMouseMove, options);
  useEventListener(window, 'mouseup', handleMouseUp, options);
  var commonMenuProps = {
    sortOptions: sortOptions,
    selectedSortOption: selectedSortOption,
    setSelectedSortOption: setSelectedSortOption,
    isPinned: isPinned,
    onIsPinnedChange: disableUserPinnableColumns ? undefined : handleIsPinnedChange,
    onMoveLeft: disableUserReorderableColumns || isPinned && columnIndex === 0 || !isPinned && columnIndex === minUnpinnedColumnIndex ? undefined : handleMoveLeft,
    onMoveRight: disableUserReorderableColumns || isPinned && columnIndex === minUnpinnedColumnIndex - 1 || !isPinned && columnIndex === maxUnpinnedColumnIndex ? undefined : handleMoveRight,
    onFocus: function onFocus() {
      var _columnHeaderRef$curr4;
      return (_columnHeaderRef$curr4 = columnHeaderRef.current) === null || _columnHeaderRef$curr4 === void 0 ? void 0 : _columnHeaderRef$curr4.focus();
    },
    columnId: id,
    columnHeaderRef: columnHeaderRef
  };
  useEffect(function () {
    if (labelRef.current) {
      setEllipsisShown(labelRef.current.clientWidth < labelRef.current.scrollWidth);
    }
  }, [isResizing]);
  var computedWidth = useComputedWidth(widthBuffer, width);
  return /*#__PURE__*/React__default.createElement(Tooltip, {
    content: label,
    disabled: !ellipsisShown
  }, /*#__PURE__*/React__default.createElement("div", {
    role: "columnheader",
    "data-testid": dataTestId,
    "aria-rowindex": 1,
    "aria-colindex": columnIndex + 1 // aria-colindex is one-indexed
    ,
    "aria-sort": isSortable ? isSorted ? selectedSortOption.direction : 'none' : undefined,
    onKeyDown: handleKeyDown,
    onFocus: onFocus,
    onClick: isSortable ? handleClick : undefined,
    tabIndex: isFocused ? 0 : -1,
    className: classNames(styles.advancedTableColumnHeader, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.advancedTableRowChild, !isPinned), styles.isSortable, isSortable), styles.isSorted, isSorted), styles.showFocusRing, isHiddenMenuOpen), styles.isDragging, isDragging), styles.fillRemainingSpace, isFinalNonRowActionsColumn && width === undefined)),
    style: {
      width: computedWidth
    },
    ref: mergeRefs(columnHeaderRef, dragRef, dropRef, ref)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.advancedTableColumnHeaderLabel, _defineProperty(_defineProperty(_defineProperty({}, styles.leftAligned, alignment === 'left'), styles.centerAligned, alignment === 'center'), styles.rightAligned, alignment === 'right')),
    ref: labelContainerRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.advancedTableColumnHeaderLabelText,
    ref: labelRef
  }, label), selectedSortIcon), hasMenu && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AdvancedTableColumnHeaderMenu, _extends({}, commonMenuProps, {
    isOpen: isMenuOpen,
    setIsOpen: setIsMenuOpen,
    anchor: /*#__PURE__*/React__default.createElement(IconButton, {
      tabIndex: -1,
      "aria-hidden": "true",
      className: styles.advancedTableColumnHeaderMenu
    }, /*#__PURE__*/React__default.createElement(ChevronDownIcon, null))
  })), /*#__PURE__*/React__default.createElement(AdvancedTableColumnHeaderMenu, _extends({}, commonMenuProps, {
    isOpen: isHiddenMenuOpen,
    setIsOpen: setIsHiddenMenuOpen,
    highlightedIndex: hiddenMenuHighlightedIndex,
    onHighlightedIndexChange: setHiddenMenuHighlightedIndex,
    anchor: /*#__PURE__*/React__default.createElement("div", {
      tabIndex: -1,
      "aria-hidden": "true",
      onFocus: function onFocus() {
        var _columnHeaderRef$curr5;
        (_columnHeaderRef$curr5 = columnHeaderRef.current) === null || _columnHeaderRef$curr5 === void 0 || _columnHeaderRef$curr5.focus();
      },
      className: styles.advancedTableColumnHeaderMenuHiddenAnchor
    })
  }))), dropTargetSide && !isRowActionMenuColumn && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.dropTargetLine, _defineProperty(_defineProperty({}, styles.dropTargetLeft, dropTargetSide === 'left'), styles.dropTargetRight, dropTargetSide === 'right')),
    style: {
      height: tableHeight
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.dropTargetMarker, _defineProperty(_defineProperty({}, styles.dropTargetLeft, dropTargetSide === 'left'), styles.dropTargetRight, dropTargetSide === 'right'))
  })), onWidthChange && /*#__PURE__*/React__default.createElement("div", {
    "aria-hidden": true,
    className: styles.resizeHandle,
    style: {
      height: tableHeight
    },
    onMouseDown: handleMouseDown
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.resizeLine, _defineProperty({}, styles.isResizing, isResizing))
  }))));
});

export { AdvancedTableColumnHeader as default };
